<script setup>
import { ref, computed, onMounted,onUnmounted, h, nextTick } from 'vue'
import axios from 'axios'
import 'vue3-carousel/carousel.css'
import { Carousel, Slide } from 'vue3-carousel'
import Loading from '@/components/Loading.vue'
import ClassificationItem from '@/components/ClassificationItem.vue'
import FoodItem from '@/components/FoodItem.vue'
import FoodItemDescription from '@/components/FoodItemDescription.vue'
import InfoIcon from '@/components/InfoIcon.vue'
import OrderIcon from '@/components/OrderIcon.vue'
//import AboutEstablishment from '@/views/AboutEstablishment.vue'
import UserOrder from '@/views/UserOrder.vue'
import { useOrder } from '@/composables/useOrder.js'
import {useToast} from 'vue-toast-notification'

const { order, addToOrder } = useOrder()

const toast = useToast()

const props = defineProps({
  id: {
    type: Object,
    required: true
  },
  nav: Object
})

const listItems = ref([])
const isEmpty = ref(false) 
const currentClasification = ref(0)

async function fetchEstablishmentFood() {
  try {
    const { data } = await axios.get(`menu?branch_id=${props.id}`)
    
    const grouped = Object.values(
        data.reduce((acc, product) => {
            const catName = product.category_name;

            if (!acc[catName]) {
                acc[catName] = {
                    name: catName,
                    image: product.category_icon,
                    items: []
                };
            }

            acc[catName].items.push({
                id: product.id,
                branch_id: product.branch_id,
                title: product.title,
                description: product.description,
                price: product.price,
                photo: product.photo
            });

            return acc;
        }, {})
    );

    listItems.value = grouped || []
    isEmpty.value = listItems.value.length === 0;
  } catch (error) {
    console.error('Error al obtener los datos:', error)
  }
}

function setCurrentClasification(index) {
  currentClasification.value = index
}

function prepareOrder(item) {
  addToOrder({ name: item.title, price: item.price })
  toast.open({
    message: `Agregaste ${item.title} a tu orden`,
    type: 'default',
    position: 'bottom'
  })
}
/*
{
  render() {
    return h('button', { 
      class: 'me-2', 
      onClick: () => props.nav.push(AboutEstablishment) }, 
      h(InfoIcon)
    )
  }
},
*/
onMounted(async () => {
    await nextTick()
    props.nav.setButtons([
      {
        render() {
          return h('button', { 
            class: 'me-2', 
            quantity: "",
            onClick: () => props.nav.push(UserOrder, {id: props.id}) }, 
            h(OrderIcon)
          )
        }
      }
    ])
    
    fetchEstablishmentFood()
})

onUnmounted(() => {
  props.nav.setButtons([]) 
})
</script>

<template>
    <div v-if="listItems.length > 0">
        <div class="px-2 mb-4">
          <small class="text-lg block pt-2 text-gray-800/25 dark:text-white/25 pb-0 font-bold">Hola!</small>
          <label class="text-4xl pb-2 block font-bold">¿Algun antojo?</label>
          <label class="text-2xl block mb-8 font-thin">Ordena & Disfruta</label>

          <div class="categories-container">
            <div
              class="categories-scroll"
              ref="scrollContainer"
            >
             
                <ClassificationItem
                  @click="setCurrentClasification(0)"
                  :class="{ active: currentClasification === 0 }"
                  title="Todos"
                  icon="img/Menu.png"
                />
             
              
                <ClassificationItem
                v-for="(data, i) in listItems"
                :key="i"
               
                @click="setCurrentClasification(i + 1)"
                  :title="data.name"
                  :icon="data.image"
                  :class="{ active: currentClasification === i + 1 }"
                />
              
            </div>
          </div>
        </div>
        <div v-if="currentClasification === 0">
          <div v-for="(data, i) in listItems" :key="i">
            <h3 class="mx-3 mt-6">{{ data.name }}</h3>
            <Carousel 
              v-bind="carouselConfig" 
              :items-to-show="1.5" 
              :wrap-around="true" 
              :mouse-drag="true" 
              :pause-autoplay-on-hover="true"
            >
              <Slide 
                v-for="(item, j) in data.items" 
                :key="j" 
              >
                <FoodItem
                  :item="item"
                  @add="prepareOrder(item)"
                />
              </Slide>
            </Carousel>
          </div>
        </div>
        <div v-else>
          <h3 class="mx-3 mt-6">{{ listItems[currentClasification - 1].name }}</h3>
          <div class="grid grid-cols-1">
            <div 
              v-for="(item, j) in listItems[currentClasification - 1].items" 
              :key="j" 
            >
              <FoodItemDescription
                  :item="item"
                  @add="prepareOrder(item)"
              />
            </div>
          </div>
        </div>
     </div>
     <Loading
        v-else
        :isEmpty="isEmpty"
        title="Lo sentimos"
        description="No hemos encontrado ningún menú para este establecimiento."
     />
</template>

<style scoped>
.categories-container {
  overflow-x: auto;
  -ms-overflow-style: none;  /* IE y Edge */
  scrollbar-width: none;     /* Firefox */
}

.categories-container::-webkit-scrollbar {
  display: none;  /* Chrome, Safari y Opera */
}

.categories-scroll {
  display: flex;
  padding: 0.5rem;
  scrollbar-width: thin; 
}
</style>